import { render, staticRenderFns } from "./BatteryAlarmList.vue?vue&type=template&id=2e948a39&scoped=true&"
import script from "./BatteryAlarmList.vue?vue&type=script&lang=js&"
export * from "./BatteryAlarmList.vue?vue&type=script&lang=js&"
import style0 from "./BatteryAlarmList.vue?vue&type=style&index=0&id=2e948a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e948a39",
  null
  
)

export default component.exports